export default __webpack_public_path__ + "static/media/meditate.82e2bb1f.gif";